import PropTypes from "prop-types"
import React from "react"

import Slider from "../../../slider/slider"

const RangeProductFilter = ({ productFilter }) => {
  return (
    <div className="_fp-filter-group__item">
      <Slider
        onAfterChange={([low, high]) => {
          productFilter.setRangeMin(low)
          productFilter.setRangeMax(high)
        }}
        value={[productFilter.filterMinimum, productFilter.filterMaximum]}
        min={productFilter._minimumValue}
        max={productFilter._maximumValue}
        label={productFilter.prefix}
        renderThumbLabel={(value) => (
          <>
            {value}
            {productFilter.suffix}
          </>
        )}
        step={productFilter.stepSize}
      />
    </div>
  )
}

RangeProductFilter.propTypes = {
  productFilter: PropTypes.object.isRequired,
}

export default RangeProductFilter
